/** One aggregated row of the "por forma de pagamento" table — the endpoint's response body. */
export class ConferenciaFormaPagamentoModel {
  idPdvPagamentoDetalhe: number;
  formaPagamento: string;
  previsto: number;
  realizado: number;
  diferenca: number;
  temDiferenca: boolean;
}

export class ConferenciaResumoTotalModel {
  previsto: number;
  realizado: number;
  diferenca: number;
}

export type QuebraSeveridade = 'CONTROLADO' | 'MONITORAR' | 'INVESTIGAR';

/** Replaces `FechamentoModel`: KPIs de conferência e percentual de quebra por forma de pagamento. */
export class ConferenciaResumoModel {
  porFormaPagamento: ConferenciaFormaPagamentoModel[];
  total: ConferenciaResumoTotalModel;
  qtdSessoesComDiferenca: number;
  qtdLinhasComDiferenca: number;
  volumeManuseado: number;
  pctQuebra: number;
  severidade: QuebraSeveridade;
}

export function emptyConferenciaResumo(): ConferenciaResumoModel {
  return {
    porFormaPagamento: [],
    total: { previsto: 0, realizado: 0, diferenca: 0 },
    qtdSessoesComDiferenca: 0,
    qtdLinhasComDiferenca: 0,
    volumeManuseado: 0,
    pctQuebra: 0,
    severidade: 'CONTROLADO',
  };
}
